import { Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import Header from "../../../../components/commonComponents/modals/Header";
import AttachmentsManager from "../sidebar/AttachmentsManager";
import NotesSection from "./NotesSection";
import { getRandomColorsBassedOnLetters } from "../../../../helper/colors";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SettingsIcon from "../../../../assets/customSVG/channels/SettingsIcon";
import Delivered from "../../../../assets/customSVG/inbox/Delivered";
import { ICONS } from "../../../../assets/icons";
import {
  AttributeList,
  cityListApi,
  countryListApi,
  stateListApi,
  ProfileAttributeValueCreate,
  ProfileAttributeValueUpdate,
  crmTagSingleAssign,
  crmTagRemove,
} from "../../../crm/api/Api";
import "../../styles/popover.css";
import { showErrorToast, showSuccessToast } from "../../../../components/commonComponents/gxAntdToast/toastUtils";
import NotificationContext from "../../../../providers/NotificationProvider";
import CustomContactLayout from "./CustomContactLayout";
import { gender } from "../../../../constant/app/crm/crm";
import { fetchCustomContactLayout, whatsappBusinessNumbers } from "../../api/Api";
import { useFeature } from "../../../../hooks/useFeatureGating";
import { FEATURES } from "../../../../constant/featureSlugs";

const SideNavComponent = ({
  selectedPerson,
  setIsSideNavOpen,
  contactPopover,
  setContactPopover,
  data,
  type,
  journeyLists,
  attachments,
  notes,
  noteDelete,
  attachmentFilter,
  setAttachmentFilter,
  getAttachments,
  getNotes,
  setIsSideNavOpenIcon3,
  setIsSideNavOpenIcon2,
  setIsSideNavOpenIcon1,
  setIsSideNavOpenIcon4,
  profession,
  setChatToggle,
  chatToggle,
}) => {
  const { isEnabled: canUseCustomAttributes } = useFeature(FEATURES.CUSTOM_ATTRIBUTES);
  const [infoOpen, setInfoOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [businessNumberDetails, setBusinessNumberDetails] = useState(null);
  const [loadingBusinessNumber, setLoadingBusinessNumber] = useState(false);
  const [editedScope, setEditedScope] = useState(null);
  const [editedAttributes, setEditedAttributes] = useState({});
  const [editingField, setEditingField] = useState(null);
  const [tempValues, setTempValues] = useState({});
  const [isCustomizerOpen, setIsCustomizerOpen] = useState(false);
  const [layoutSections, setLayoutSections] = useState([]);
  const [isLayoutLoading, setIsLayoutLoading] = useState(false);
  const [layoutError, setLayoutError] = useState("");
  const [layoutVersion, setLayoutVersion] = useState(0);

  // State for country, state, and city dropdowns
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({ name: '', id: null });
  const [selectedState, setSelectedState] = useState({ name: '', id: null });
  const [selectedCity, setSelectedCity] = useState({ name: '', id: null });
  const [popoverVisible, setPopoverVisible] = useState({
    country: false,
    state: false,
    city: false,
  });

  // State for tag management
  const [isTagPopoverOpen, setIsTagPopoverOpen] = useState(false);

  const closeAction = (tagId) => {
    handleRemoveTag(tagId);
  };

  const handleSaveAttribute = async (attr, scope, newValue) => {
    if (!selectedPerson?.contact_person_id) {
      showErrorToast(notification, "Contact person ID is missing");
      return;
    }

    // For country/state/city, use the selected values
    let valueToSave = newValue;
    if (attr.name === 'country') {
      valueToSave = selectedCountry.name;
    } else if (attr.name === 'province' || attr.name === 'state') {
      valueToSave = selectedState.name;
    } else if (attr.name === 'city') {
      valueToSave = selectedCity.name;
    }

    setIsSaving(true);
    try {
      const basePayload = {
        contact_person_id: selectedPerson.contact_person_id,
        profile_attribute_id: attr.id,
        value: valueToSave
      };

      let response;

      // Find the existing attribute value from contact_person_values
      const existingValue = attributes.contact_person_values.find(
        v => v.contact_person_profile_attribute_id === attr.id
      );

      // If we have an existing value, update it, otherwise create a new one
      if (existingValue) {
        // Update existing value using the ID from contact_person_values
        response = await ProfileAttributeValueUpdate(currentBrand?.brand_id, {
          ...basePayload,
          id: existingValue.id
        });
      } else {
        // Create new value with the exact required fields
        response = await ProfileAttributeValueCreate({
          brand_id: currentBrand?.brand_id,
          contact_person_id: selectedPerson.contact_person_id,
          profile_attribute_id: attr.id,
          value: valueToSave
        });
      }

      if (response?.status === 200) {
        showSuccessToast(notification, response?.data?.message || `Successfully saved ${attr.label || attr.name}`);
        // Refresh attributes to get the latest data
        fetchAttributes();
      } else {
        showErrorToast(notification, response?.response?.data?.error || `Failed to save ${attr.label || attr.name}`);
      }
    } catch (error) {
      console.error(`Error saving ${attr.label || attr.name}:`, error);
      showErrorToast(notification, error.response?.data?.error || error.message || `Failed to save ${attr.label || attr.name}`);
    } finally {
      setIsSaving(false);
      setEditingField(null);
      setTempValues(prev => {
        const newValues = {...prev};
        delete newValues[attr.id];
        return newValues;
      });
    }
  };


  const [attributes, setAttributes] = useState({
    scopes: [],
    contact_person_values: [],
    contact_person_tags_list: []
  });

  // Name
  const nameAttribute = attributes?.scopes?.find(scope =>
    scope.profile_attributes?.find(attr => attr.name === 'first_name')
  )?.profile_attributes?.find(attr => attr.name === 'first_name');

  // const nameAttribute2 = attributes?.scopes?.find(scope =>
  //   scope.profile_attributes?.find(attr => attr.name === 'middle_name')
  // )?.profile_attributes?.find(attr => attr.name === 'middle_name');

  const nameAttribute3 = attributes?.scopes?.find(scope =>
    scope.profile_attributes?.find(attr => attr.name === 'last_name')
  )?.profile_attributes?.find(attr => attr.name === 'last_name');

  const nameId = nameAttribute?.id;
  // const nameId2 = nameAttribute2?.id;
  const nameId3 = nameAttribute3?.id;
    const firstname = nameId && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === nameId)?.value;
  // const middlename = nameId2 && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === nameId2)?.value;
  const lastname = nameId3 && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === nameId3)?.value;
  const fullname = firstname + (lastname ? ` ${lastname}` : '');
  // Email
  const emailAttribute = attributes?.scopes?.find(scope =>
    scope.profile_attributes?.find(attr => attr.name === 'email_address')
  )?.profile_attributes?.find(attr => attr.name === 'email_address');

  const emailId = emailAttribute?.id;
  const email = emailId && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === emailId)?.value;

  // Fetch Brand
  const { currentBrand } = useSelector((state) => state?.app);

  // Notification Context
  const notification = useContext(NotificationContext);

  // Restricted Attributes
  const restrictedAttributes = ['mobile_number', 'country_code', 'email_address', 'age', 'whatsapp_opt_out'];

  // Get input type based on attribute type
  const getInputType = (attributeType, attributeName) => {
    if (attributeName === 'gender') return 'gender';

    switch (attributeType) {
      case 'number':
        return 'number';
      case 'date':
        return 'date';
      case 'boolean':
        return 'checkbox';
      case 'string':
      default:
        return 'text';
    }
  };


    // Fetch business number details when selectedPerson changes
    useEffect(() => {
      const fetchBusinessNumber = async () => {
        if (!selectedPerson?.from_number) return;
        
        try {
          setLoadingBusinessNumber(true);
          const response = await whatsappBusinessNumbers(
            currentBrand?.brand_id,
            {
              search: selectedPerson.from_number,
              call_meta: 'false'
            }
          );
          
          if (response?.data?.wapp_business_num?.[0]) {
            setBusinessNumberDetails(response.data.wapp_business_num[0]);
          }
        } catch (error) {
          showErrorToast(notification, error.response?.data?.error || error.message);
        } finally {
          setLoadingBusinessNumber(false);
        }
      };
      
      fetchBusinessNumber();
    }, [selectedPerson?.from_number, currentBrand?.brand_id]);
    
    // Clear business number details when component unmounts
    useEffect(() => {
      return () => {
        setBusinessNumberDetails(null);
      };
    }, []);
  
    
  const fetchLayout = React.useCallback(
    async (shouldNotifyAttributes = false) => {
      if (!currentBrand?.brand_id) {
        return [];
      }

      setIsLayoutLoading(true);
      setLayoutError("");
      try {
        const response = await fetchCustomContactLayout(currentBrand?.brand_id);
        const sections = response?.data?.layout?.sections || [];
        setLayoutSections(sections);
        if (shouldNotifyAttributes) {
          setLayoutVersion((prev) => prev + 1);
        }
        return sections;
      } catch (error) {
        const message =
          error?.response?.data?.error ||
          error?.message ||
          "Unable to load contact layout.";
        setLayoutError(message);
        showErrorToast(notification, message);
        throw error;
      } finally {
        setIsLayoutLoading(false);
      }
    },
    [currentBrand?.brand_id, notification],
  );

  const fetchAttributes = React.useCallback(async () => {
    if (!selectedPerson?.contact_person_id || !currentBrand?.brand_id) {
      return;
    }

    try {
      const response = await AttributeList(
        currentBrand?.brand_id,
        selectedPerson?.contact_person_id,
      );

      if (response?.data) {
        const {
          scopes_and_attributes_list,
          contact_person_values = [],
          contact_person_tags_list = [],
        } = response.data;

        const attributeValuesMap = contact_person_values.reduce((acc, cv) => {
          acc[cv.contact_person_profile_attribute_id] = cv.value;
          return acc;
        }, {});

        let mergedScopes = [];

        if (Array.isArray(scopes_and_attributes_list)) {
          mergedScopes = scopes_and_attributes_list.map((scope) => ({
            ...scope,
            profile_attributes: Array.isArray(scope.profile_attributes)
              ? scope.profile_attributes.map((attr) => ({
                  ...attr,
                  value: attributeValuesMap[attr.id] || "",
                }))
              : [],
          }));
        }

        setAttributes({
          scopes: mergedScopes,
          contact_person_values: contact_person_values,
          contact_person_tags_list: contact_person_tags_list,
        });
      }
    } catch (error) {
      showErrorToast(
        notification,
        error?.response?.data?.error ||
          error?.message ||
          "Failed to fetch profile attributes",
      );
    }
  }, [selectedPerson?.contact_person_id, currentBrand?.brand_id, notification]);

  // CRM STATES


  useEffect(() => {
    if (!selectedPerson?.contact_person_id) {
      return;
    }

    setLayoutVersion(0);
    const loadLayout = async () => {
      try {
        await fetchLayout(true);
      } catch (error) {
        // errors handled inside fetchLayout
      }
    };

    loadLayout();
  }, [selectedPerson?.contact_person_id, currentBrand?.brand_id, fetchLayout]);

  useEffect(() => {
    if (!selectedPerson?.contact_person_id) {
      setAttributes({
        scopes: [],
        contact_person_values: [],
        contact_person_tags_list: [],
      });
      return;
    }
  }, [selectedPerson?.contact_person_id]);

  useEffect(() => {
    if (!selectedPerson?.contact_person_id) {
      return;
    }

    if (layoutVersion === 0) {
      return;
    }

    fetchAttributes();
  }, [selectedPerson?.contact_person_id, layoutVersion, fetchAttributes]);

  // Handle tag assignment
  const handleAssignTag = async (tagId) => {
    try {
      const response = await crmTagSingleAssign(
        selectedPerson?.contact_person_id,
        tagId,
        currentBrand?.brand_id
      );

      if (response?.status === 200) {
        showSuccessToast(notification, 'Tag assigned successfully');
        fetchAttributes(); // Refresh the contact data
      }
    } catch (error) {
      console.error('Error assigning tag:', error);
      showErrorToast(notification, 'Failed to assign tag');
    }
  };

  // Handle tag removal
  const handleRemoveTag = async (tagId) => {
    try {
      const response = await crmTagRemove(
        selectedPerson?.contact_person_id,
        tagId,
        currentBrand?.brand_id
      );

      if (response?.status === 200) {
        showSuccessToast(notification, 'Tag removed successfully');
        fetchAttributes(); // Refresh the contact data
      }
    } catch (error) {
      console.error('Error removing tag:', error);
      showErrorToast(notification, 'Failed to remove tag');
    }
  };

  const firstLetter =
    data?.information?.first_name !== "UNKNOWN"
      ? data?.information?.first_name?.slice(0, 1).toUpperCase()
      : selectedPerson?.profile_name?.slice(0, 1).toUpperCase();

  const colors = firstLetter ? getRandomColorsBassedOnLetters(firstLetter) : "";

  // attachment filter
  const handleFilterChange = (filter) => {
    setAttachmentFilter(filter);
    getAttachments(filter);
  };

  // --- single file download ---
  const handleDownloadItem = async (item) => {
    try {
      // 1) fetch the file
      const res = await fetch(item.file_url);
      if (!res.ok) throw new Error("Network response was not ok");

      // 2) turn it into a blob
      const blob = await res.blob();

      // 3) make an object URL
      const url = window.URL.createObjectURL(blob);

      // 4) create a temporary link with download attr
      const link = document.createElement("a");
      link.href = url;
      link.download = item.file_name; // suggests the filename
      document.body.appendChild(link);
      link.click();

      // 5) clean up
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      // optionally show a user error toast
    }
  };

  // --- bulk download as ZIP ---
  const handleDownloadItems = async (selectedItems) => {
    try {
      // Option A: parallel downloads
      await Promise.all(
        selectedItems.map(async (item) => {
          const res = await fetch(item.file_url);
          if (!res.ok) throw new Error(`Failed to fetch ${item.file_name}`);
          const blob = await res.blob();

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = item.file_name;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
      );

      // Option B: sequential downloads (uncomment if you run into throttling)
      // for (const item of selectedItems) {
      //   const res = await fetch(item.file_url);
      //   const blob = await res.blob();
      //   const url = window.URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = item.file_name;
      //   document.body.appendChild(link);
      //   link.click();
      //   link.remove();
      //   window.URL.revokeObjectURL(url);
      // }
    } catch (err) {
      console.error("Bulk download failed:", err);
      // show an error toast if you like
    }
  };

  // navigate to contact details page
  const navigate = useNavigate();

  // Fetch tags on component mount
  useEffect(() => {
    if (data?.tags && data.tags.length > 0) {
      // setSelectedTagIds(data.tags.map(tag => tag.id));
    }
  }, [data?.tags]);

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await countryListApi();
        if (response?.data?.data) {
          setCountryList(response.data.data);
        } else {
          console.error('Unexpected API response format:', response);
          setCountryList([]);
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        setCountryList([]);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states when country is selected
  const fetchStates = async (countryId) => {
    try {
      const response = await stateListApi(countryId);
      if (response?.data?.data) {
        setStateList(response.data.data);
      } else {
        console.error('Unexpected API response format for states:', response);
        setStateList([]);
      }
    } catch (error) {
      console.error('Error fetching states:', error);
      setStateList([]);
    }
  };

  // Fetch cities when state is selected
  const fetchCities = async (stateId) => {
    try {
      const response = await cityListApi(stateId);
      if (response?.data?.data) {
        setCityList(response.data.data);
      } else {
        console.error('Unexpected API response format for cities:', response);
        setCityList([]);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
      setCityList([]);
    }
  };

  // Handle country selection
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setSelectedState({ name: '', id: null });
    setSelectedCity({ name: '', id: null });
    setStateList([]);
    setCityList([]);
    if (country.id) {
      fetchStates(country.id);
    }
    setPopoverVisible({ ...popoverVisible, country: false });
  };

  // Handle state selection
  const handleStateSelect = (state) => {
    setSelectedState(state);
    setSelectedCity({ name: '', id: null });
    setCityList([]);
    if (state.id) {
      fetchCities(state.id);
    }
    setPopoverVisible({ ...popoverVisible, state: false });
  };

  // Handle city selection
  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setPopoverVisible({ ...popoverVisible, city: false });
  };

  const handleLayoutRefresh = React.useCallback(
    async ({ shouldReloadAttributes = false } = {}) => {
      try {
        await fetchLayout(shouldReloadAttributes);
      } catch (error) {
        // errors handled inside fetchLayout
      }
    },
    [fetchLayout],
  );

  return (
    <div className="flex-1 h-full">
      {type === "contact" && (
        <div className="w-[20vw] h-full">
          <div className="w-100 flex-row align-center space-between bg-white">
            <Header
              title={"Contact Details"}
              handleCancel={() => {
                setIsSideNavOpen(false);
                setIsSideNavOpenIcon4(false);
                setIsSideNavOpenIcon3(false);
                setIsSideNavOpenIcon2(false);
                setIsSideNavOpenIcon1(false);
              }}
              className="new-header"
              goToContact={() => {
                navigate(`/user/crm/${selectedPerson?.contact_person_id}`, { state: { colors }});
              }}
              action={
                selectedPerson ? (
                  <Tooltip title={canUseCustomAttributes ? "Customize" : "Upgrade to customize layout"}>
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        if (canUseCustomAttributes) {
                          setIsCustomizerOpen(true);
                        }
                      }}
                      className={`p-2 rounded-full hover:bg-[#F1F4F6] focus:outline-none ${!canUseCustomAttributes ? "opacity-50 cursor-not-allowed" : ""}`}
                    >
                      <SettingsIcon size={16} />
                    </button>
                  </Tooltip>
                ) : null
              }
            />
          </div>
          <CustomContactLayout
            brandId={currentBrand?.brand_id}
            selectedPerson={selectedPerson}
            fullName={fullname}
            email={email}
            contactOrigin={data?.information?.contact_origin}
            contactPopover={contactPopover}
            setContactPopover={setContactPopover}
            attributes={attributes}
            infoOpen={infoOpen}
            setInfoOpen={setInfoOpen}
            editedScope={editedScope}
            setEditedScope={setEditedScope}
            restrictedAttributes={restrictedAttributes}
            editedAttributes={editedAttributes}
            setEditedAttributes={setEditedAttributes}
            tempValues={tempValues}
            setTempValues={setTempValues}
            editingField={editingField}
            setEditingField={setEditingField}
            popoverVisible={popoverVisible}
            setPopoverVisible={setPopoverVisible}
            selectedCountry={selectedCountry}
            selectedState={selectedState}
            selectedCity={selectedCity}
            handleCountrySelect={handleCountrySelect}
            handleStateSelect={handleStateSelect}
            handleCitySelect={handleCitySelect}
            countryList={countryList}
            stateList={stateList}
            cityList={cityList}
            showErrorToast={showErrorToast}
            notification={notification}
            gender={gender}
            handleSaveAttribute={handleSaveAttribute}
            isSaving={isSaving}
            getInputType={getInputType}
            isTagPopoverOpen={isTagPopoverOpen}
            setIsTagPopoverOpen={setIsTagPopoverOpen}
            handleAssignTag={handleAssignTag}
            handleRemoveTag={handleRemoveTag}
            loadingBusinessNumber={loadingBusinessNumber}
            businessNumberDetails={businessNumberDetails}
            closeAction={closeAction}
            isCustomizerOpen={isCustomizerOpen}
            setIsCustomizerOpen={setIsCustomizerOpen}
            showSuccessToast={showSuccessToast}
            layoutSections={layoutSections}
            layoutLoading={isLayoutLoading}
            layoutError={layoutError}
            onLayoutRefresh={handleLayoutRefresh}
          />
        </div>
      )}

      {type === "attachments" && (
        <div
          className="flex flex-col w-[20vw] h-screen mb-10"
          style={{ overflowY: "auto" }}
        >
          <div className="w-100 flex flex-col align-center space-between bg-white">
            <Header
              title={"Attachments"}
              handleCancel={() => {
                setIsSideNavOpen(false);
                setIsSideNavOpenIcon4(false);
                setIsSideNavOpenIcon3(false);
                setIsSideNavOpenIcon2(false);
                setIsSideNavOpenIcon1(false);
              }}
              className="new-header"
            />
          </div>
          <div
            className="flex-1 flex-col overflow-hidden bg-white"
            style={{ boxShadow: "inset 0 6px 10px -4px rgba(0, 0, 0, 0.05)" }}
          >
            <AttachmentsManager
              items={attachments}
              activeFilter={attachmentFilter}
              onFilterChange={(filter) => {
                handleFilterChange(filter);
              }}
              onDownloadItem={handleDownloadItem}
              onDownloadItems={handleDownloadItems}
            />
          </div>
        </div>
      )}
      

      {type === "notes" && (
        <NotesSection
          setIsSideNavOpen={setIsSideNavOpen}
          notes={notes}
          setIsSideNavOpenIcon1={setIsSideNavOpenIcon1}
          setIsSideNavOpenIcon2={setIsSideNavOpenIcon2}
          setIsSideNavOpenIcon3={setIsSideNavOpenIcon3}
          setIsSideNavOpenIcon4={setIsSideNavOpenIcon4}
          noteDelete={noteDelete}
          setChatToggle={setChatToggle}
          chatToggle={chatToggle}
        />
      )}

      {type === "journey" && (
        <div className="w-[20vw] mb-10">
          <div className="w-100 flex-row align-center space-between bg-white">
            <Header
              title={"Customer Journey"}
              handleCancel={() => {
                setIsSideNavOpen(false);
                setIsSideNavOpenIcon4(false);
                setIsSideNavOpenIcon3(false);
                setIsSideNavOpenIcon2(false);
                setIsSideNavOpenIcon1(false);
              }}
              className="new-header"
            />
          </div>
          {journeyLists?.length > 0 ? (
            <div className="h-[90vh] overflow-scroll bg-white mb-20">
              {Object.entries(
                journeyLists
                  ?.sort((a, b) => new Date(b?.send_at) - new Date(a?.send_at))
                  .reduce((acc, item) => {
                    const date = new Date(item?.send_at);
                    const monthYear = date.toLocaleString("en-US", {
                      month: "long",
                      year: "numeric",
                    });
                    if (!acc[monthYear]) acc[monthYear] = [];
                    acc[monthYear].push(item);
                    return acc;
                  }, {})
              ).map(([monthYear, items]) => (
                <div key={monthYear} className="mb-10">
                  <div className="ml-[18px] mt-20">
                    <span className=" text-[0.75rem] font-[600] text-[var(--font-600)] bg-[var(--BG-25)] ptb-10 px-[15px] b-radius-6">
                      {monthYear}
                    </span>
                  </div>
                  {items.map((item) => {
                    const date = new Date(item?.send_at);

                    const formattedDate = date.toLocaleString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    });

                    return (
                      <div
                        key={item?.id}
                        className="relative flex-row ml-[18px] mr-5 pl-20 mb-10"
                      >
                        <div
                          className="flex flex-col items-center"
                          style={{ transform: "translate(0, 26px)" }}
                        >
                          <div className="absolute w-2 h-2 bg-[#7B54FF] rounded-full"></div>
                          <div className="w-10 h-full border border-1 mt-4"></div>
                        </div>

                        <div className="flex flex-col space-y-1 ml-[15px] mt-20 ">
                          <span className="journey14px-500  flex-row">
                            {item?.status === "READ" && (
                              <span className="mr-10 mt-5">
                                <Delivered color={"#1778F2"} />
                              </span>
                            )}
                            {item?.message}
                          </span>
                          <span className="inbox12px-500 text-[var(--font-600)]">
                            {formattedDate}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          ) : (
            <div className="m-10 w-100 text-center  h-[83vh]">
              <img src={ICONS?.emptyLoader} alt="emptyLoader" />
              <img src={ICONS?.emptyLoader} alt="emptyLoader" />
              {/* <span className="pt-10 text-[1rem] font-[600] text-[var(--textBlack)]">
                No data found
              </span> */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SideNavComponent;
